// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"624f1043636f3212a0ef","655":"96aa13ed925963f333b5"}[chunkId] + ".js";
};